<template>
  <div v-if="showSelector" class="mb-4">
    <p class="text-sm font-semibold mb-2 block">{{ $t("selectPostType") }}</p>
    <div class="flex gap-4">
      <div
        v-for="option in postTypeOptions"
        :key="option.value"
        class="p-4 border rounded-lg flex items-center gap-2 duration-300 relative bg-surface-100 dark:bg-surface-800 font-medium"
        :class="{
          'border-primary text-primary pr-10': selectedPostType === option.value,
          'border-surface-400 dark:border-surface-700 hover:border-primary dark:hover:border-primary hover:text-primary dark:hover:text-primary':
            selectedPostType !== option.value,
        }"
        role="button"
        @click="selectPostType(option.value)"
      >
        <div
          class="p-2 text-white rounded-md flex items-center justify-center bg-primary w-10 h-10"
        >
          <i :class="option.icon" class="text-xl" />
        </div>
        <p>{{ option.label }}</p>
        <i
          v-if="selectedPostType === option.value"
          class="pi pi-check-circle text-primary absolute right-4 top-1/2 -translate-y-1/2"
        />
      </div>
    </div>
    <p v-if="selectedPostType === 'reels'" class="text-xs mt-2 opacity-70">
      {{ $t("reelsPostingNote") }}
    </p>
  </div>
</template>

<script setup lang="ts">
import type { IntegrationTypes } from "@/types/account";

const props = defineProps<{
  platform: IntegrationTypes;
  hasVideo: boolean;
  hasImages: boolean;
}>();

const selectedPostType = defineModel<string>({
  required: true,
});

const { t } = withI18nHelpers();

const showSelector = computed(() => {
  return props.hasVideo && props.platform === "facebook";
});

const postTypeOptions = computed(() => {
  const options = [];

  if (props.platform === "facebook") {
    options.push(
      {
        value: "message",
        label: t("regularPost"),
        icon: "pi pi-file-edit",
      },
      {
        value: "reels",
        label: t("facebookReel"),
        icon: "pi pi-video",
      }
    );
  }

  return options;
});

function selectPostType(postType: string) {
  selectedPostType.value = postType;
}

// Set default post type based on platform
onMounted(() => {
  if (!selectedPostType.value && showSelector.value) {
    selectedPostType.value = "message";
  }
});
</script>
